var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5a.31.31 0 01.161.046c.05.03.088.077.113.14l.687 1.706 1.767.162a.308.308 0 01.162.07c.04.036.07.082.091.139a.3.3 0 01-.085.334l-1.34 1.215.404 1.806a.277.277 0 01-.013.185.342.342 0 01-.106.135.3.3 0 01-.154.061.271.271 0 01-.17-.044L12 9.996l-1.517.96a.272.272 0 01-.17.043.301.301 0 01-.154-.06.34.34 0 01-.106-.136.277.277 0 01-.013-.185l.403-1.806-1.34-1.215a.305.305 0 01-.084-.334.347.347 0 01.09-.139.31.31 0 01.162-.07l1.768-.162.687-1.705a.275.275 0 01.113-.141.31.31 0 01.16-.046z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3h3.496c.552 0 1.003.448 1.004 1 .005 2.838-.196 5.45-4.5 5.923V10c0 3.06-2.29 5.582-5.25 5.951V20.5H16a.75.75 0 010 1.5H8a.75.75 0 010-1.5h3.25v-4.549A6 6 0 016 10v-.077C1.696 9.45 1.495 6.838 1.5 4c0-.552.452-1 1.004-1H6V2h12v1zM7.5 10a4.5 4.5 0 009 0V3.5h-9V10zM3.004 4.5c.018 1.253.124 2.098.483 2.694.276.458.86 1.008 2.513 1.218V4.5H3.004zM18 8.412c1.652-.21 2.237-.76 2.513-1.218.358-.596.465-1.441.483-2.694H18v3.912z",
    fill: "currentColor"
  })));
}
SvgWinners.displayName = 'Winners';
export default SvgWinners;